import { useState } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { NavLink } from "react-router-dom";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
} from "reactstrap";
import Tools from "../../icons/tools.svg";
import Icon from "../../components/Icon/Icon";
import LogoWhite from "../../icons/logo-white.svg";
import Profile from "../../containers/Profile/Profile";
import styles from "./Header.module.scss";

const Header = ({ user }) => {
  const [collapsed, setCollapsed] = useState(true);

  const toggleNavbar = () => setCollapsed(!collapsed);
  const navigation = [
    {
      name: "Spot editor",
      link: `/spot-editor`,
      userRole: ["researcher", "admin"],
    },
    {
      name: "Hot spot editor",
      link: `/hot-spot-editor`,
      userRole: ["researcher", "admin"],
    },
    { name: "Check new", link: `/check`, userRole: ["admin"] },
    { name: "Check New Publications", link: `/check-publications`, userRole: ["admin"] },
    {
      name: "Add news",
      link: `/add-news`,
      userRole: ["researcher", "admin", "content_manager"],
    },
    { name: "Add blog", link: `/add-blog`, userRole: ["researcher", "admin"] },
  ];
  const { role } = user;

  return (
    <header>
      <Navbar className={styles.headerContainer} dark>
        <NavbarBrand className="mr-auto">
          <Icon name={LogoWhite} />
        </NavbarBrand>
        <div className={styles.desktopNavigation}>
          <ul className={styles.desktopNavigationInner}>
            {navigation.map((item, index) => {
              if (!item.userRole.find((roleUser) => roleUser === role)) {
                return null;
              }
              return (
                <li key={index}>
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? styles.navigationActiveLink : ""
                    }
                    to={item.link}
                  >
                    {item.name}
                  </NavLink>
                </li>
              );
            })}
          </ul>
          {role === "admin" && (
            <NavLink
              className={({ isActive }) =>
                isActive
                  ? cx(styles.tools, styles.navigationActiveLink)
                  : styles.tools
              }
              to="/tools"
            >
              <Icon name={Tools}>Tools</Icon>
            </NavLink>
          )}
          <Profile user={user} />
        </div>
        <>
          <NavbarToggler className={styles.toggler} onClick={toggleNavbar} />
          <Collapse isOpen={!collapsed} navbar className={styles.collapse}>
            <Nav navbar className={styles.mobileNavigation}>
              {navigation.map((item, index) => {
                if (!item.userRole.find((roleUser) => roleUser === role)) {
                  return null;
                }
                return (
                  <NavItem key={index}>
                    <NavLink
                      to={item.link}
                      className={({ isActive }) =>
                        isActive
                          ? cx(
                              styles.mobileNavigationLink,
                              styles.navigationActiveLink
                            )
                          : styles.mobileNavigationLink
                      }
                    >
                      {item.name}
                    </NavLink>
                  </NavItem>
                );
              })}
            </Nav>
            <div className={styles.control}>
              {role === "admin" && (
                <NavLink
                  className={({ isActive }) =>
                    isActive
                      ? cx(styles.tools, styles.navigationActiveLink)
                      : styles.tools
                  }
                  to="/tools"
                >
                  <Icon name={Tools}>Tools</Icon>
                </NavLink>
              )}
              <Profile user={user} />
            </div>
          </Collapse>
        </>
      </Navbar>
    </header>
  );
};

Header.propTypes = {
  Collapse: PropTypes.element,
  Navbar: PropTypes.element,
  NavbarToggler: PropTypes.element,
  NavbarBrand: PropTypes.element,
  Nav: PropTypes.element,
  NavItem: PropTypes.element,
};

export default Header;
